/**
 * Post-draw kind suggestions from geometry shape (Phase 3 pilot).
 */

const POLYGON_KINDS = [
  'room tag boundary',
  'suite area',
  'occupancy area',
  'gross building area',
];

const LINE_KINDS = [
  'linear dimension',
  'wall centerline',
  'property line',
];

const RECT_KINDS = [
  'room tag boundary',
  'equipment footprint',
  'parking stall',
];

/**
 * @param {object} component — user-drawn component with geometry
 * @returns {string[]} suggested kind strings (may be empty)
 */
export function suggestKindsForUserMarkup(component) {
  const geom = component?.geometry;
  if (!geom) return [];

  const type = geom.type || 'polyline';
  const ptCount = geom.points?.length || 0;

  if (type === 'bbox' || (type === 'polygon' && ptCount === 4)) {
    return RECT_KINDS;
  }
  if (type === 'polygon' && ptCount >= 3) {
    return POLYGON_KINDS;
  }
  if (type === 'polyline' && ptCount === 2) {
    return LINE_KINDS;
  }
  if (type === 'polyline' && ptCount > 2) {
    return ['wall centerline', 'property line', 'linear dimension'];
  }
  if (type === 'arc') {
    return ['radial dimension', 'arc opening'];
  }
  return [];
}
